<script>
    export let orders;

    import { chart } from "svelte-apexcharts";
    import { getRandomBlue } from "../utils.js";

    let p = 24 * 60 * 60 * 1000; // milliseconds in a day

    let itemsSold = {};
    let series;
    let totalIncome;

    let colors = [];

    for (let i = 0; i < 50; i++) {
        colors.push(getRandomBlue());
    }

    function processOrders() {
        if (!orders || orders.length == 0) return;

        itemsSold = {};
        totalIncome = 0;

        orders.forEach((order) => {
            order.items.forEach((item) => {
                if (!itemsSold[item.name]) {
                    itemsSold[item.name] = item.count;
                } else {
                    itemsSold[item.name] += item.count;
                }
            });
            totalIncome += order.sum;
        });

        options.series = Object.values(itemsSold);
        options.labels = Object.keys(itemsSold);
    }

    $: {
        if (orders) {
            processOrders();
        }
    }

    var options = {
        series: [],
        legend: {
            fontSize: "16px",
            fontFamily: "Helvetica, Arial",
            fontWeight: 400,
            labels: {
                useSeriesColors: false,
            },
            markers: {
                fillColors: colors,
                colors: colors,
            },
            onItemClick: {
                toggleDataSeries: true,
            },
            onItemHover: {
                highlightDataSeries: true,
            },
        },
        chart: {
            type: "donut",
        },
        fill: {
            colors,
        },
        stroke: {
            show: false,
        },
        tooltip: {
            enabled: true,
            enabledOnSeries: undefined,
            shared: true,
            followCursor: false,
            intersect: false,
            inverseOrder: false,
            custom: undefined,
            fillSeriesColor: false,
            theme: false,
            style: {
                fontSize: "14px",
                fontFamily: undefined,
            },
            onDatasetHover: {
                highlightDataSeries: true,
            },
            marker: {
                show: false,
            },
            fixed: {
                enabled: false,
                position: "topRight",
                offsetX: 0,
                offsetY: 0,
            },
        },
    };

</script>

<div class="chart">
    <div use:chart={options} />
    <div class="details">
        <div class="totalIncome">ס"הכ הכנסות: {totalIncome || '0'}₪</div>
    </div>
</div>

<style>
    :global(.apexcharts-tooltip) {
        background: #f7f7f7;
        color: #7c7c7c;
        box-shadow: 0px 10px 12px -10px #000 !important;
    }
    :global(.apexcharts-tooltip-marker) {
        background: var(--blue1);
        color: white;
        margin-left: 10px;
    }
    :global(.apexcharts-legend-text) {
        margin-right: 15px;
    }
    :global(.apexcharts-legend) {
        right: 0 !important;
    }
    :global(.apexcharts-legend-series) {
        margin-top: 5px !important;
        padding: 5px;
        border-radius: 40px;
    }
    :global(.apexcharts-legend-series:hover) {
        background: #edf9ff;
    }
    :global(.apexcharts-canvas) {
        margin-left: auto;
        margin-right: auto;
    }
    .chart {
        position: relative;
        background: rgb(255 255 255 / 90%);
        border-radius: 4px;
        box-shadow: 0 3px 10px -10px;
        margin-bottom: 30px;
        padding-top: 40px;
        margin: 10px;
    }
    .details {
        direction: rtl;
        padding: 20px;
        margin-top: 30px;
        margin-right: 30px;
        background: #ffffffd9;
        display: inline-block;
        margin-bottom: 20px;
        border-radius: 40px;
        box-shadow: 2px 5px 30px -20px;
    }

    .totalIncome {
        font-size: 20px;
    }

    .items {
        font-size: 18px;
    }

    .items > li {
        display: block;
    }

</style>
